export const smartSegmentatationLabels = {
  0: 'index 0',
  1: 'index 1',
  2: 'index 2',
  3: 'index 3',
  4: 'index 4',
};
